const EXTENSION_BY_MIME = {
  "image/png": ".png",
  "image/jpeg": ".jpg",
};

// The cropper encodes the canvas, then wraps that blob in a File. The File
// constructor drops the blob's type unless it is passed explicitly, and the
// original filename often still says .jpg while the canvas bytes are PNG.
// client-service accepts the upload only when the extension and Content-Type
// name the same allowlisted image type.
export function croppedImageMimeType(imageisPNG) {
  return imageisPNG === false ? "image/jpeg" : "image/png";
}

export function croppedImageFile(blob, originalName, mimeType) {
  const type = mimeType || blob?.type || "image/png";
  const extension = EXTENSION_BY_MIME[type] || ".png";
  const base = String(originalName || "")
    .trim()
    .replace(/\.[^./\\]+$/, "");
  return new File([blob], `${base || "logo"}${extension}`, { type });
}
